import { createApi } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchQuery } from './helpers/fetchQuery';

export const websitesApi = createApi({
  reducerPath: 'websitesApi',
  tagTypes: ['Websites', 'Website', 'AccountEntitlements', 'VentureWebsites'],
  baseQuery: fetchQuery({ basePath: '/v2', subDomain: 'websites.api' }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: builder => ({})
});
